import { Button, Form, Image, Input, Select, Space, Switch } from "antd";
import axios from "axios";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { responseNotification } from "../../../utils/notify";
import { jcTypeArray } from "../../../utils";
import { authenticateToken } from "../../../utils/auth";

const { TextArea } = Input;
const { Option } = Select;

interface EditOrderProps {
  visibleData?: any;
  onCloseMethod?: () => void;
  setType?: (val) => void;
  handleSearch?: (val, field) => void;
  type?: string;
}

const EditOrder = (props: EditOrderProps) => {
  const { visibleData, onCloseMethod, setType, handleSearch, type } = props;

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [thumbImageUrl, setThumbImageUrl] = useState<string>();

  const onSubmit = async (data) => {
    setLoading(true);

    const readyData = data && {
      name: data.name,
      type: data.type,
      categoryId: data.categoryId,
      brandId: data.brandId,
      shopId: data.shopId,
      campaignId: data.campaignId,
      keyword: data.keyword,
      isPopular: data.isPopular,
      description: data.description,
      productImage: data.productImage,
      images: data.images,
      variations: data?.variations?.map((variant) => ({
        variationName: variant.variationName,
        price: {
          mrp: parseFloat(variant.mrp) * 1,
          tp: parseFloat(variant.tp) * 1,
        },
        productDiscount: {
          flat: parseFloat(variant.flat) || 0,
          percentage: parseFloat(variant.percentage) || 0,
        },
        stock: parseFloat(variant.stock) || 0,
      })),
    };

    await axios
      .post(`${process.env.REACT_APP_ORDER_API}/order`, readyData, {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setLoading(false);

        if (res.status === 200) {
          responseNotification("Order Create Successfully", "success");
          form.resetFields();
          if (onCloseMethod) {
            onCloseMethod();
          }
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(
            res.data?.message || "something wrong",
            "warning"
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  useEffect(() => {
    if (visibleData) {
      // form.resetFields([...visibleData]);
      console.log("visibleData", visibleData);
    }
  }, [form, visibleData]);

  const resetData = () => {
    form?.resetFields();
    setImageUrls([]);
    setThumbImageUrl("");
    setType("");
  };

  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          initialValues={{
            ...visibleData,
          }}
          form={form} // like ref
          layout="vertical"
          // requiredMark="optional"
          autoComplete="off"
        >
          <h4 style={{ fontWeight: "bolder", marginTop: 0 }}>
            Basic Information
          </h4>

          <Form.Item
            hasFeedback
            label="Order Name"
            rules={[
              {
                required: true,
                message: "Order Name is Required!",
              },
            ]}
            name="name"
          >
            <Input id="name" type="text" placeholder="Enter Order Name" />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Type"
            rules={[
              {
                required: true,
                message: "Type is required!",
              },
            ]}
            name="type"
          >
            <Select
              placeholder="Shop Type"
              onChange={(val) => {
                setType(val);
                form.resetFields(["shopId", "categoryId", "brandId"]);
              }}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Select.Option value={type} key={i}>
                  {type?.split("_").join(" ")}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item hasFeedback label="Brand" name="brandId">
            <Select
              showSearch
              placeholder="Select Brand"
              optionFilterProp="children"
              // onChange={(val) => setBrandId(val)}
              onSearch={(val) => {
                handleSearch(val, "brand");
              }}
              filterOption={(input, option) =>
                option.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {[]?.map((brand) => (
                <Option value={brand.id}>{brand.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <div className="popular-product major">
            <div className="">
              <Form.Item
                style={{ minWidth: "100%" }}
                hasFeedback
                label="Popular Order?"
                name="isPopular"
              >
                <Switch checkedChildren="Yes" unCheckedChildren="No" />
              </Form.Item>
            </div>
          </div>

          <Form.Item
            hasFeedback
            label="Description"
            rules={[
              {
                required: true,
                message: "Description is Required!",
              },
            ]}
            name="description"
          >
            <TextArea
              id="description"
              placeholder="Enter Order Description"
              rows={6}
            />
          </Form.Item>

          <h4 style={{ fontWeight: "bolder" }}>Order Variations</h4>

          <Form.List
            name="variations"
            rules={[
              {
                validator: async (_, names) => {
                  if (!names || names.length < 1) {
                    return Promise.reject(
                      new Error("At least 1 variation required!")
                    );
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }: any) => (
                  <Space
                    key={key}
                    style={{ display: "flex", marginBottom: 8 }}
                    align="baseline"
                  >
                    <Form.Item
                      {...restField}
                      name={[name, "variationName"]}
                      fieldKey={[fieldKey, "variationName"]}
                      hasFeedback
                      // label="title"
                      rules={[{ required: true, message: "Required!" }]}
                      style={{ minWidth: 200 }}
                    >
                      <Input placeholder="Enter title" />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "mrp"]}
                      fieldKey={[fieldKey, "mrp"]}
                      hasFeedback
                      // label="Price (MRP)"
                      rules={[{ required: true, message: "Required!" }]}
                    >
                      <Input placeholder="Enter MRP" />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "tp"]}
                      fieldKey={[fieldKey, "tp"]}
                      hasFeedback
                      // label="Price (TP)"
                      rules={[{ required: true, message: "Required!" }]}
                    >
                      <Input placeholder="Enter TP" />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "flat"]}
                      fieldKey={[fieldKey, "flat"]}
                      hasFeedback
                    >
                      <Input placeholder="Flat Discount (Tk.)" />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "percentage"]}
                      fieldKey={[fieldKey, "percentage"]}
                      hasFeedback
                      style={{ maxWidth: 100 }}
                    >
                      <Input placeholder="% Discount 00.00" />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "stock"]}
                      fieldKey={[fieldKey, "stock"]}
                      hasFeedback
                      style={{ maxWidth: 100 }}
                    >
                      <Input placeholder="Stock" />
                    </Form.Item>

                    <MinusCircleOutlined
                      onClick={() => remove(name)}
                      style={{ color: "#e62d26" }}
                    />
                  </Space>
                ))}

                <Form.Item
                  style={{ width: "100%", flex: "1 1 100%", marginBottom: 5 }}
                >
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    // danger
                  >
                    Add Variation
                  </Button>
                </Form.Item>

                <Form.ErrorList errors={errors} />
              </>
            )}
          </Form.List>
          <h4 style={{ fontWeight: "bolder" }}>Order Images</h4>
          <Form.Item
            name="productImage"
            label="Thumbnail"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Order Image Url is required",
              },
              {
                // @ts-ignore
                type: "url",
                warningOnly: true,
                message: "Enter valid url",
              },
            ]}
          >
            <Input
              placeholder="Enter Image Url"
              onChange={async (e) => {
                setThumbImageUrl(e.target.value);
              }}
            />
          </Form.Item>
          <div className="mb-4 d-flex-l" style={{ minWidth: "100%" }}>
            {thumbImageUrl && (
              <div className="mr-2">
                <Image
                  src={thumbImageUrl}
                  height={150}
                  className="img img-thumbnail"
                />
              </div>
            )}
          </div>
          <Form.List
            name="images"
            rules={[
              {
                validator: async (_, names) => {
                  if (!names || names.length < 1) {
                    return Promise.reject(
                      new Error("At least 1 image url required!")
                    );
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields.map((field, index) => (
                  <Form.Item
                    required={true}
                    key={field.key}
                    label={index === 0 ? "Images" : undefined}
                    style={{
                      flex: "1 1 100%",
                    }}
                  >
                    <Form.Item
                      {...field}
                      validateTrigger={["onChange", "onBlur"]}
                      rules={[
                        {
                          required: true,
                          message: "Order Image Url is required",
                        },
                        {
                          // @ts-ignore
                          type: "url",
                          warningOnly: true,
                          message: "Enter valid url",
                        },
                      ]}
                      noStyle
                    >
                      <Input
                        placeholder="Enter Image Url"
                        onChange={(e) => {
                          const addedUrls = Array.from(imageUrls);
                          addedUrls[field.name] = e.target.value;
                          setImageUrls(addedUrls);
                        }}
                      />
                    </Form.Item>

                    <MinusCircleOutlined
                      className="dynamic-delete-button"
                      onClick={() => {
                        remove(field.name);
                        const addedUrls = imageUrls.filter(
                          (_, index) => index !== field.name
                        );
                        setImageUrls(addedUrls);
                      }}
                      style={{ color: "#e62d26", marginLeft: 15 }}
                    />
                  </Form.Item>
                ))}
                <Form.Item
                  style={{ width: "100%", flex: "1 1 100%", marginBottom: 5 }}
                >
                  <Button
                    type="dashed"
                    onClick={() => {
                      add();
                      const addedUrls = Array.from(imageUrls);
                      addedUrls.push("");
                      setImageUrls(addedUrls);
                    }}
                    style={{ width: "40%" }}
                    icon={<PlusOutlined />}
                  >
                    Add Image
                  </Button>
                </Form.Item>
                <Form.ErrorList errors={errors} />
              </>
            )}
          </Form.List>
          <div
            className="mt-4 d-flex-l"
            style={{ minWidth: "100%" }}
            id="imgTh"
          >
            {imageUrls?.filter((item) => item).length
              ? imageUrls.map(
                  (imgUrl) =>
                    imgUrl && (
                      <div className="mr-2">
                        <Image
                          src={imgUrl}
                          height={150}
                          className="img img-thumbnail"
                        />
                      </div>
                    )
                )
              : undefined}
          </div>

          <div className="buttons-container">
            <Button
              disabled={loading}
              loading={(loading ? "loading" : undefined) as any}
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={resetData}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default EditOrder;
